import { render, staticRenderFns } from "./Umk.vue?vue&type=template&id=679ef6db&scoped=true&"
import script from "./Umk.vue?vue&type=script&lang=js&"
export * from "./Umk.vue?vue&type=script&lang=js&"
import style0 from "./Umk.vue?vue&type=style&index=0&id=679ef6db&scoped=true&lang=css&"
import style1 from "./Umk.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ef6db",
  null
  
)

export default component.exports